function normalizeComparableText(value) {
	return String(value || "")
		.trim()
		.replace(/\s+/g, " ");
}

function getPrimaryBlockText(block) {
	if (!block || typeof block !== "object") return "";

	switch (block.type) {
		case "text":
			return block.text || "";
		case "table":
		case "card":
			return block.title || "";
		case "approval":
		case "analytics":
		case "confirmation":
		case "failure":
			return block.summary || block.title || "";
		default:
			return "";
	}
}

export function getMessageText(message) {
	return String(message?.content || message?.text || message?.body || "").trim();
}

export function isMessageTextRepresentedByBlocks(messageText, blocks) {
	const normalizedMessageText = normalizeComparableText(messageText);
	if (!normalizedMessageText || !Array.isArray(blocks) || blocks.length === 0) {
		return false;
	}

	// The approval card already contains the action and its confirmation prompt.
	const prepared = normalizedMessageText.match(/^I prepared ([\w.]+)\. Please approve before I make changes\.$/);
	if (prepared && blocks.some((block) => block?.type === "approval" && block.title === prepared[1])) return true;

	const blockTexts = blocks
		.map(getPrimaryBlockText)
		.map(normalizeComparableText)
		.filter(Boolean);

	return (
		blockTexts.some((blockText) => blockText === normalizedMessageText) ||
		normalizeComparableText(blockTexts.join("\n")) === normalizedMessageText
	);
}

// Combine the outcome and its details without changing persisted messages.
export function compactAssistantBlocks(blocks = []) {
	if (!Array.isArray(blocks)) return [];
	const result = [];
	for (let index = 0; index < blocks.length; index += 1) {
		const block = blocks[index];
		const next = blocks[index + 1];
		if (block?.type === "confirmation" && next?.type === "card" && !block.items?.length && !next.outcome) {
			result.push({ ...next, outcome: block });
			index += 1;
		} else result.push(block);
	}
	return result;
}
